<div *ngIf="type() && type() === 'appProvisionProfile'">
  <label for="app-provision-profile">
    <i class="upload-icon fa-solid fa-upload"></i>
    <input
      (change)="onProvisionUpload($event)"
      type="file"
      id="app-provision-profile"
      style="display: none"
      accept=".mobileprovision"
    />
  </label>
</div>

<div *ngIf="type() && type() === 'oneSignalProvisionProfile'">
  <label for="onesignal-provision-profile">
    <i class="upload-icon fa-solid fa-upload"></i>
    <input
      (change)="onProvisionUpload($event)"
      type="file"
      id="onesignal-provision-profile"
      style="display: none"
      accept=".mobileprovision"
    />
  </label>
</div>
